import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useSelector, useDispatch } from "react-redux";
import { clearStatus, setState } from "./fileTransferSlice";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

function SharedComponent() {
  const dispatch = useDispatch();
  const fileTransfer = useSelector((state) => state.fileTransfer);
  const { isSuccess, isSuccess_Info, isFailed, isFailed_Info, isError, isAlert_Info, isAlert,  } =
    fileTransfer;

  const handleCloseSnackbar = () => {
    dispatch(clearStatus());
  };
  const handleCloseSnackbarSecond = () => {
		dispatch(setState("isAlert", false));
    dispatch(setState("isAlert_Info", ""));
	};

  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleCloseSnackbar}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isSuccess}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        action={action}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          sx={{ width: "100%" }}
        >
          {isSuccess_Info}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isFailed}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        action={action}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="warning"
          sx={{ width: "100%" }}
        >
          {isFailed_Info}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={isError}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        action={action}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="error"
          sx={{ width: "100%" }}
        ></Alert>
      </Snackbar>

      {isAlert_Info !== "" && (
        <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            sx ={{marginTop: "50px"}}
            open={isAlert}
            autoHideDuration={5000}
            onClose={handleCloseSnackbarSecond}
          >
            <Alert
              onClose={handleCloseSnackbarSecond}
              severity="warning"
              sx={{ width: "100%" }}
            >
              {isAlert_Info}
            </Alert>
          </Snackbar>
			  )}
    </div>
  );
}

export default SharedComponent;
